import AgentActivity from 'models/agent_activity';
import changeCurrentLocation from 'actions/lib/change_current_location';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import Snippet, { SnippetContent, SnippetChannels } from 'models/answers/snippet';
import SnippetCompositionUploads from 'actions/composition/lib/snippet_composition_uploads';
import SnippetEditor from 'models/location/snippet_editor';

export default class SwitchSnippet {
  constructor(context) {
    this.context = context;
  }

  run({ referencedAnswerId, snippetId }) {
    this.updateCurrentLocation(snippetId, referencedAnswerId);
    this.fetchSnippet(snippetId);
  }

  updateCurrentLocation(snippetId, referencedAnswerId) {
    changeCurrentLocation(this.context, SnippetEditor.create({ referencedAnswerId, snippetId }));
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.KNOWLEDGE_BASE });
  }

  fetchSnippet(snippetId) {
    if (!snippetId) {
      this.removeSnippetComposition();
      return;
    }
    let snippetComposition = this.context.stores.snippetComposition.get();
    if (!snippetComposition || snippetComposition.id !== snippetId) {
      let placeholderSnippet = Snippet.create({
        id: snippetId,
        content: SnippetChannels.create({
          anyChannel: SnippetContent.create(),
          info: SnippetContent.create(),
          message: SnippetContent.create(),
          selfService: SnippetContent.create(),
        }),
      });
      this.context.stores.snippetComposition.set(placeholderSnippet);
      this.context.stores.snippetComposition.setLoading();
      this.context.gateways.snippet.fetch({ snippetId });
      this.context.stores.snippetLinks.set([]);
    }
  }

  removeSnippetComposition() {
    let snippetComposition = this.context.stores.snippetComposition.get();
    if (!snippetComposition) {
      return;
    }

    SnippetCompositionUploads.fromComposition(snippetComposition).cleanUp(this.context);
    this.context.stores.snippetComposition.remove();
  }
}
